import { TableColumnMeta } from "ds/components/Table/types";

export const GROUP_INTEGRATION_LIST_ITEM_TEST_ID = "group-integration-list-item";

export const SLACK_TABLE_STORAGE_KEY = "slackIntegrationsTableStorageKey";
export const SLACK_TABLE_FILTERS_STORAGE_KEY = "slackIntegrationsFiltersStorageKey";

export enum SLACK_COLUMN_ID {
  NAME = "NAME",
  SLACK_ID = "SLACK_ID",
  SPACES = "SPACES",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const SLACK_TABLE_COLUMNS_CONFIG: Record<SLACK_COLUMN_ID, TableColumnMeta> = {
  [SLACK_COLUMN_ID.NAME]: {
    id: SLACK_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [SLACK_COLUMN_ID.SLACK_ID]: {
    id: SLACK_COLUMN_ID.SLACK_ID,
    title: "ID",
    minWidth: 120,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [SLACK_COLUMN_ID.SPACES]: {
    id: SLACK_COLUMN_ID.SPACES,
    title: "Spaces",
    minWidth: 100,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [SLACK_COLUMN_ID.DROPDOWN]: {
    id: SLACK_COLUMN_ID.DROPDOWN,
    title: "More actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<SLACK_COLUMN_ID, string> = {
  [SLACK_COLUMN_ID.NAME]: "name",
  [SLACK_COLUMN_ID.SLACK_ID]: "slackId",
  [SLACK_COLUMN_ID.SPACES]: "spaces",
  [SLACK_COLUMN_ID.DROPDOWN]: "dropdown",
};
